import { render } from "./MemberTagSearch.vue?vue&type=template&id=641b423e&scoped=true"
import script from "./MemberTagSearch.vue?vue&type=script&lang=js"
export * from "./MemberTagSearch.vue?vue&type=script&lang=js"

import "./MemberTagSearch.vue?vue&type=style&index=0&id=641b423e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641b423e"]])

export default __exports__